import { render, staticRenderFns } from "./LoadingView.vue?vue&type=template&id=3d483809&scoped=true&"
import script from "./LoadingView.vue?vue&type=script&lang=js&"
export * from "./LoadingView.vue?vue&type=script&lang=js&"
import style0 from "./LoadingView.vue?vue&type=style&index=0&id=3d483809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d483809",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VProgressCircular,VRow})
